export default function(store, { host }) {
  const Product = store.defineModel('product', {
    defaultValues: {
      activeProcessingEvents: null,
      conversationCount: 0,
      organizations: null,
      unreadCount: 0,
      unreadPriorityCount: 0,
    },

    transientAttrs: [
      'conversationCount',
      'organizations',
      'unreadCount',
      'unreadPriorityCount',
    ],

    afterAssignment(entity) {
      const { id } = entity
      entity.productRoles = host.userRoles.getByProductId(id)
      if (entity.activeProcessingEvents === null) entity.activeProcessingEvents = []
      if (entity.organizations === null) entity.organizations = []
    },
  })

  return Product
}
